/* import __COLOCATED_TEMPLATE__ from './seller-postings-tabbar-item.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

class SellerPostingsTabbarItem extends Component {
  get classNames() {
    return clsx(
      'seller-postings-tabbar__item',
      this.args.selected && 'seller-postings-tabbar__item--selected',
    );
  }

  get label() {
    const { count, label } = this.args;
    return Number.isInteger(count) ? `${label}(${count})` : label;
  }
}

export default SellerPostingsTabbarItem;
